import {message, Modal} from "antd";
import locales from "../locales";

export function showConfirm(title: string, callback: () => void) {
  Modal.confirm({
    title,
    onOk: callback,
    okText: locales.yes,
    cancelText: locales.cancel,
  });
}

export function showSaveConfirm(callback: () => void) {
  showConfirm(locales.save_confirm, callback);
}

export function showDeleteConfirm(callback: () => void, title?: string) {
  showConfirm(title ?? locales.delete_confirm, callback);
}

export function showSuccessNotification(text: string) {
  message.success(text);
}

export function showSaveSuccessNotification() {
  showSuccessNotification(locales.save_success);
}

export function showDeleteSuccessNotification() {
  showSuccessNotification(locales.delete_success);
}

export function showSaveErrorNotification() {
  message.error(locales.save_error);
}

export function showErrorModal(text: string) {
  Modal.error({
    title: locales.error,
    content: text,
    okText: locales.ok,
  })
}

export function showSuccessModal(text: string) {
  Modal.success({
    title: locales.save_success,
    content: text,
    okText: locales.ok,
  })
}




// WEBPACK FOOTER //
// ./src/utils/dialogs.tsx